import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TeamOutlined, Loading3QuartersOutlined } from '@ant-design/icons'
import { FormButton, SegmentList, SegmentListWrapper } from '../targeting.styled'
import { Button, ConfigProvider, Form, Input, message, Modal, Statistic } from 'antd'
import { useSelector } from 'react-redux'
import { addTarget } from '../../../apis/target'

function TargetConfirmModal (props) {
  const { show, setShow, data, params, retarget, goBack = () => {} } = props
  const { t: ln_t } = useTranslation()
  const { segments, segmentsInvoice } = data || {}
  const { handleFetchParams = () => {} } = params || {}
  const [form] = Form.useForm()
  const user = useSelector((state) => state.user)
  const { nowBrand, nowGroup } = user || {}
  const [isLoading, setIsLoading] = useState(false)
  const segmentIsInvoice = Boolean(segmentsInvoice?.length)

  const handleClose = back => {
    form.resetFields()
    setShow(false)
    if (back) goBack()
  }
  const handleCreate = async ({ name = data.name }) => {
    setIsLoading(false)
    const reqBody = {
      name,
      brandId: nowBrand,
      groupId: nowGroup,
      price: segments?.reduce((all, item) => all + item.price, 0) || 0,
      segments: (segmentIsInvoice ? segmentsInvoice : segments).map(i => ({ id: i.id, price: i.price || 0 })),
      dataExportId: data?.dataExportId,
      segmentType: segmentIsInvoice ? 'invoice' : 'audience',
      ...data?.refreshToken ? { refreshToken: data?.refreshToken } : {}
    }
    const result = await addTarget(reqBody)
    if (result?.status !== 202) {
      const { code, message } = result?.data || {}
      const errMsg = code === 'SequelizeUniqueConstraintError' ? ln_t('message.error.resourceExist') : (code || message)
      message.error(errMsg)
      return setIsLoading(false)
    }
    if (retarget) {
      handleFetchParams('add', {})
      message.success(ln_t('message.success.retarget'))
    } else message.success(ln_t('message.success.create'))
    setIsLoading(false)
    handleClose(true)
  }

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Modal title={retarget ? ln_t('target.retarget') : ln_t('target.createTarget')} open={show} onCancel={() => handleClose()} footer={null}>
        <Form form={form} layout="vertical" requiredMark={false} onFinish={handleCreate} style={{ paddingTop: '12px' }}>
          {retarget
            ? <Form.Item name="name" label={`${ln_t('target.name')} :`} rules={[{ required: true, message: `${ln_t('util.pleaseEnter')} ${ln_t('target.name')}` }]}>
                <Input placeholder={`${ln_t('util.pleaseEnter')} ${ln_t('target.name')}`} />
              </Form.Item>
            : ''}
          <Form.Item name="segment" label={`${ln_t('target.selectedSegment')} :`} rules={[{ required: false }]}>
            <SegmentListWrapper>
              {(segmentIsInvoice ? segmentsInvoice : segments)?.map(({ id, name, previewCount, count }) => (
                <SegmentList key={id}>
                  <div><TeamOutlined /> {name}</div>
                  <div className="d-flex">
                    {ln_t('segment.quantity')} :
                    {(segmentIsInvoice ? count : previewCount)
                      ? <Statistic value={previewCount || count} style={{ marginLeft: '8px' }} />
                      : <Loading3QuartersOutlined style={{ marginLeft: '8px' }} spin />}
                  </div>
                </SegmentList>
              ))}
            </SegmentListWrapper>
          </Form.Item>
          {retarget ? <div>{ln_t('message.confirm.retarget')}</div> : ''}
          <FormButton>
            <Button type="default" onClick={() => handleClose()}>{ln_t('util.cancel')}</Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
      </Modal>
    </ConfigProvider>
  )
}

export default TargetConfirmModal
